import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarCheck = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.5 2V4H15.5V2H17V4H21V13H19.5V10H4.5V19.5H12V21H3V4H7V2H8.5ZM4.5 8.5H19.5V5.5H4.5V8.5ZM22.3033 15.625L16.9793 22.3824L13.6894 19.0419L14.7581 17.9894L16.8541 20.1176L21.125 14.6967L22.3033 15.625Z",
		fill: "currentcolor"
	})]
});
export default SvgCalendarCheck;
